import styled from 'styled-components';
import { ButtonIcon as ButtonIconBase } from '../../style';

export const ButtonIcon = styled(ButtonIconBase).attrs({
    marginLeft: 0,
    marginRight: 0,
})`
    padding: 0;
`;
